export default () => jQuery(($) => {
	if (!!window.IntersectionObserver) {
		let observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio > 0) {
						let target = $(entry.target);
						const startTime = Date.now();
						const duration = target.attr('data-duration') ? target.attr('data-duration') : 2000;
						let remaining = duration;
						const startVal = Number(target.html());
						const endVal = Number(target.attr('data-end-value'));
						const frame = function () {
							const timestamp = Date.now();
							const progress = timestamp - startTime;
							remaining = duration - progress;
							let frameVal = startVal + (endVal - startVal) * (progress / duration);
							frameVal = (frameVal > endVal) ? endVal : frameVal;
							frameVal = Math.round(frameVal);
							target.html(frameVal);
							if (remaining > 0) {
								requestAnimationFrame(frame);
							} else {
								observer.unobserve(entry.target);
								target.parent().html(target.siblings(".countup__original").html());
								//target.remove();
							}
						};
						requestAnimationFrame(frame);
					}
				});
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.75
			}
		);
		$('.countup').each(function () {
			$(this).removeClass('countup');
			var duration = 2000;
			if ($(this).attr('data-duration')) {
				duration = $(this).attr('data-duration');
			} else {
				$(this).attr('class').split(' ').forEach(item => {
					var matches = item.match(/\bcountup__duration--(\d+)\b/);
					if (matches) duration = matches[1];
				});
			}
			$(this).html($(this).html().replace(/(\d+)/g, `<span class="countup" data-duration="${duration}">$1</span>`));
		});
		$('.countup').each(function () {
			$(this).wrapInner('<span class="countup__original hide" />');
			let placeholder = $('<span class="countup__animated" aria-hidden="true">0</span>');
			const endVal = Number($(this).text());
			const endValSize = endVal.toString().length;
			placeholder.attr('data-end-value', $(this).text());
			if ($(this).attr('data-duration')) {
				placeholder.attr('data-duration', $(this).attr('data-duration'));
			}
			let spacerString = "";
			for (let i = 0; i < endValSize; i++) {
				spacerString = spacerString + "0";
			}
			let spacer = $('<span class="countup__spacer" aria-hidden="true">' + spacerString + '</span>')
			$(this).append(placeholder);
			$(this).append(spacer);
			observer.observe(placeholder[0]);
		});
	}
});
